// extracted by mini-css-extract-plugin
export var icon = "_ws-0";